import ListingRow  from './component'

export default ListingRow